import { useEffect, useState } from "react";
import { StreamingSession } from "../services/streamingSession.service";
import { useSettings } from "./useSettings";

export default function useStreamingSession(session: StreamingSession): [
    streamingContent: string
] {
    const settings = useSettings();
    const [streamingContent, setStreamingContent] = useState<string>("");

    useEffect(() => {
        async function doWork() {
            const cachedMessage = await session.getCachedMessage(settings.useSessionStorage);
            setStreamingContent(cachedMessage);
            await session.register(newMessage => setStreamingContent(oldMessage => (oldMessage ?? "") + newMessage));
        }

        doWork();

        return () => setStreamingContent("");
    }, [session]);

    return [streamingContent];
}